// src/content/infrastructure/ui-services/regulationUiService.ts

import type { Regulation } from "~/src/content/domain/models/Regulation";
import { useCompetitionStore } from "~/app/stores/competitionStore";
import { useWebContext } from "~/app/composables/webContext";
import type { NitroFetchOptions } from "nitropack";

interface RegulationUiService {
  getRegulationPdf: (lang: string) => Promise<Regulation | undefined>;
}

const regulationUiService = (): RegulationUiService => ({
  getRegulationPdf,
});

export default regulationUiService;

function getCurrentRegionId(): number | undefined {
  const { region } = useCompetitionStore();
  return region?.id;
}

async function getRegulationPdf(lang: string): Promise<Regulation | undefined> {
  const regionId = getCurrentRegionId();
  const { webContext: ctx } = useWebContext();
  if (!regionId) {
    console.error("Invalid regionId.");
    return undefined;
  }
  const opts: NitroFetchOptions<any> = { query: { ctx, lang } };

  try {
    const data = await $fetch<Regulation | undefined>(`/api/cms/${regionId}/regulations`, opts);
    if (data) {
      return data;
    } else {
      console.error("Regulation not found in CMS.");
    }
  } catch (e) {
    console.error("Error fetching regulation.");
  }
}
